module.exports = __webpack_public_path__ + "img/sixpackcarrier30.450220b2.jpg";